// extracted by mini-css-extract-plugin
module.exports = {"ListA1":"Partners_ListA1__dJbXV"};